import { Seo } from "@/components/Seo";
import { PageHero } from "@/components/PageHero";
import { Reveal } from "@/components/Reveal";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    desc: "How DHIYAA SOLAR ENERGY handles information submitted through this website.",
    body: [
      "DHIYAA SOLAR ENERGY respects the privacy of visitors to this website. Information submitted through enquiry forms, contact forms or other communication channels may be used to respond to enquiries, provide quotations, arrange site visits and provide information relating to our products and services.",
      "We do not knowingly sell or disclose customer information to unrelated third parties except where required for legitimate business operations, legal compliance, service delivery or applicable regulatory requirements.",
      "Information you share with us — such as your name, phone number, email address, location and electricity usage details — is used solely to process your enquiry and to design an appropriate solar solution for you.",
      "If you have any questions about how your information is handled, please contact us at info@dhiyaasolarenergy.in or call +91 98949 80894.",
    ],
  },
  terms: {
    title: "Terms & Conditions",
    desc: "Terms governing the use of the DHIYAA SOLAR ENERGY website.",
    body: [
      "The content of this website is provided for general information about DHIYAA SOLAR ENERGY and the solar energy solutions we offer. By using this website, you agree to use it only for lawful purposes.",
      "Quotations, system designs and proposals are provided after site assessment and are subject to site conditions, electricity consumption patterns, applicable regulations and equipment availability.",
      "Government scheme and subsidy information presented on this website is for general guidance. Eligibility, amounts and procedures are governed by the applicable official scheme guidelines and portals.",
      "All brand names and trademarks displayed on this website belong to their respective owners.",
    ],
  },
  disclaimer: {
    title: "Disclaimer",
    desc: "Important information about the estimates and content on this website.",
    body: [
      "The information provided on this website is for general informational purposes. Solar system generation, savings, project costs, subsidy eligibility and payback periods vary depending on system capacity, location, electricity consumption, roof orientation, shading, equipment specifications, installation conditions, applicable regulations and market prices.",
      "Government subsidy and scheme information is subject to change. Customers should verify current eligibility, subsidy amounts, empanelment requirements and applicable procedures through the relevant official government/utility portals before proceeding.",
      "Any brand names and trademarks displayed on this website belong to their respective owners.",
    ],
  },
};

export default function Legal({ page }) {
  const c = CONTENT[page] || CONTENT.privacy;
  return (
    <>
      <Seo title={`${c.title} | DHIYAA SOLAR ENERGY`} description={c.desc} />
      <PageHero eyebrow="DHIYAA SOLAR ENERGY" title={c.title} subtitle={c.desc} />
      <section className="mx-auto max-w-3xl px-4 py-16 sm:px-6" data-testid={`legal-${page}`}>
        {c.body.map((p, i) => (
          <Reveal key={i} delay={i * 0.05}>
            <p className="mb-5 leading-relaxed text-slate-600">{p}</p>
          </Reveal>
        ))}
      </section>
    </>
  );
}
